(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ContactForUser', ContactForUser);

    ContactForUser.$inject = ['$resource'];
    function ContactForUser ($resource) {
        var resourceUrl =  'api/contacts/user/:username';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data ? data[0] : data;
                }
            },
            'update': { method:'PUT' }
        });
    }

})();
